import { fmt } from "../lib/calc";
import { useFitText } from "../hooks/useFitText";
import { StatusBadge } from "./StatusBadge";

const Metric = ({ label, value, id, big, tone }) => {
  const ref = useFitText(value);
  return (
    <div className={`metric ${big ? "big" : ""} ${tone || ""}`}>
      <span className="metric-label">{label}</span>
      <span ref={ref} className="metric-value" data-testid={`metric-${id}`}>{value}</span>
    </div>
  );
};

const profitTone = (v) => (v === null ? "" : v >= 0 ? "pos" : "neg");

export const ResultsPanel = ({ r, children }) => (
  <section className="results" data-testid="results-panel">
    <StatusBadge status={r.status} testId="status-badge-verdict" />
    <div className="metric-hero">
      <Metric big id="projected-profit" label="Projected Profit" value={fmt.money(r.profit)} tone={profitTone(r.profit)} />
      <Metric big id="margin-pct" label="Margin" value={fmt.pct(r.marginPct)} tone={profitTone(r.profit)} />
    </div>
    <div className="metric-quote">
      <Metric id="recommended-quote" label={`Recommended Quote${r.margin ? ` @ ${Math.round(r.margin * 100)}%` : ""}`} value={fmt.money(r.recommendedQuote)} />
    </div>
    <div className="metric-grid">
      <Metric id="offer" label="Offer" value={fmt.money(r.offer)} />
      <Metric id="true-trip-cost" label="True Trip Cost" value={fmt.money(r.trueCost)} />
      <Metric id="total-miles" label="Total Miles" value={fmt.miles(r.totalMiles)} />
      <Metric id="loaded-miles" label="Loaded Miles" value={fmt.miles(r.loadedMiles)} />
      <Metric id="fuel-cost" label="Fuel Cost" value={fmt.money(r.fuelCost)} />
      <Metric id="rev-loaded-mile" label="Rev / Loaded Mi" value={fmt.cpm(r.revPerLoadedMile)} />
      <Metric id="be-total-cpm" label="BE Total CPM" value={fmt.cpm(r.beTotalCpm)} />
      <Metric id="be-loaded-cpm" label="BE Loaded CPM" value={fmt.cpm(r.beLoadedCpm)} />
    </div>
    {children}
  </section>
);

export const MobileHud = ({ r }) => (
  <div className="hud" data-testid="mobile-results-hud">
    <StatusBadge status={r.status} compact testId="hud-status-badge" />
    <div className="hud-nums">
      <span className={`hud-profit ${profitTone(r.profit)}`} data-testid="hud-profit">{fmt.money(r.profit)}</span>
      <span className="hud-sub" data-testid="hud-margin">{fmt.pct(r.marginPct)} · Quote {fmt.money(r.recommendedQuote)}</span>
    </div>
  </div>
);
